export enum PaymentFrequencyEnum {
    Monthly = "Monthly",
    Every3Months = "Every 3 months",
    Yearly = "Yearly",
    Month = "Month",
    Day = "Day",
    Year = "Year",
    Annual = "Annual",
    Quarterly = "Quarterly"
}